import React from 'react'
import axios from 'axios';
import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Link,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    '@global': {
      body: {
          height: '100vh',
          margin: '0',
          backgroundImage: "url(" + "https://marketplace.canva.com/EAD2xCSkyLM/4/0/800w/canva-blue-green-gradient-coronavirus-symptoms-explainer-instagram-post-TkSIGzIE6ao.jpg" + ")",
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
          backgroundColor:'grey',
          backgroundSize: 'contain'
      },
    },

  }));

function Info() {
    const classes = useStyles()
    return (
        <div>
           
        </div>
    )
}

export default Info
